import Vue from "vue";
import Router from "vue-router";
import Index from "./views/index.vue";
Vue.use(Router);
// function ifLogin(to, from, next) {
//   if (localStorage.getItem("logined")) {
//     next();
//   } else {
//     MessageBox.confirm("立即登录")
//       .then(action => {
//         next({ path: "/login" });
//       })
//       ["catch"](action => {
//         next(false);
//       });
//   }
// }

export default new Router({
  // mode: "history",
    routes: [
        // mode: "history",
        // base: "/wap/mobile/",
        {
            path: "/",
            // path: "",
            name: "index",
            component: Index,
            meta: {
                title: "沃米易学"
            }
        },
        {
            path: "/login",
            name: "login",
            component: () =>
                import ( /* webpackChunkName: "login" */ "./views/login.vue"),
            meta: {
                title: "登录沃米"
            }
        },
        {
            path: "/register",
            name: "register",
            component: () =>
                import ( /* webpackChunkName: "register" */ "./views/register.vue"),
            meta: {
                title: "注册"
            }
        },
        {
            path: "/myvideo",
            name: "myvideo",
            component: () =>
                import ( /* webpackChunkName: "myvideo" */ "./views/myvideo.vue"),
            meta: {
                title: "我的课程",
                login: true
            }
        },
        {
            path: "/videoplay",
            name: "videoplay",
            component: () =>
                import ( /* webpackChunkName: "myvideo" */ "./views/videoplay.vue"),
            meta: {
                title: "我的课程",
                login: true
            }
        },
        {
            path: "/listenBook",
            name: "listenBook",
            component: () =>
                import ( /* webpackChunkName: "myvideo" */ "./views/listenBook.vue"),
            meta: {
                title: "天天听书"
            }
        },
        {
            path: "/bookvideo:id",
            name: "bookvideo",
            component: () =>
                import ( /* webpackChunkName: "bookvideo" */ "./views/bookvideo.vue"),
            meta: {
                title: "精讲课程"
            }
        },
        {
            path: "/hotvideo:id",
            name: "hotvideo",
            component: () =>
                import ( /* webpackChunkName: "hotvideo" */ "./views/hotvideo.vue"),
            meta: {
                title: "热门直播"
            }
        },
        {
            path: "/address",
            name: "address",
            component: () =>
                import ( /* webpackChunkName: "addr" */ "./views/addr.vue"),
            meta: {
                title: "编辑地址"
            }
        },
        {
            path: "/addr",
            name: "addr",
            component: () =>
                import ( /* webpackChunkName: "addr" */ "./views/addr.vue"),
            meta: {
                title: "添加地址"
            }
        },
        {
            path: "/shopdel",
            name: "shopdel",
            component: () =>
                import ( /* webpackChunkName: "shopdel" */ "./views/shopdel.vue"),
            meta: {
                title: "商品详情"
            }
        },
        {
            path: "/editOrder",
            name: "editOrder",
            component: () =>
                import ( /* webpackChunkName: "editOrder" */ "./views/editOrder.vue"),
            meta: {
                title: "确认订单"
            }
        },
        {
            path: "/orderDel",
            name: "orderDel",
            component: () =>
                import ( /* webpackChunkName: "orderDel" */ "./views/orderDel.vue"),
            meta: {
                title: "订单详情"
            }
        },
        {
            path: "/myAddr",
            name: "myAddr",
            component: () =>
                import ( /* webpackChunkName: "myAddr" */ "./views/myAddr.vue"),
            meta: {
                title: "收货地址",
                // keepAlive:true
            }
        },
        {
            path: "/myRedpacket",
            name: "myRedpacket",
            component: () =>
                import ( /* webpackChunkName: "myRedpacket" */ "./views/myRedpacket.vue"),
            meta: {
                title: "我的红包"
            }
        },
        {
            path: "/myOrder",
            name: "myOrder",
            component: () =>
                import ( /* webpackChunkName: "myOrder" */ "./views/myOrder.vue"),
            meta: {
                title: "我的订单",
            }
        },
      {
        path: "/poster",
        name: "poster",
        component: () =>
          import ( /* webpackChunkName: "poster" */ "./views/poster.vue"),
        meta: {
          title: "宣传页",
        }
      }
    ],


});
